import(/* webpackMode: "eager" */ "/var/www/html/apps/grid-battles/src/scenario/ui/Listing/ScenariosListItem.tsx")